import React from "react";
import ForgotPasswordForm from '../form-components/ForgotPasswordForm';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from 'mdb-react-ui-kit';


const ForgotPasswordModal = (props) => {


    return (
    <MDBModal staticBackdrop tabIndex='-1' closeOnEsc={false} show={props.visible}  className="signin-modal">
      <MDBModalDialog centered scrollable>
        <MDBModalContent>
          <MDBModalHeader>
            
            <MDBBtn className='btn-close' color='none' onClick={props.hideModal}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
          <MDBModalTitle>
              <span className="modal-title">FORGOT YOUR PASSWORD?</span></MDBModalTitle>
            <ForgotPasswordForm hideModal={props.hideModal}/>
             
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}
export default ForgotPasswordModal;
